package org.solyton.solawi.bid.application.serialization

import kotlinx.serialization.builtins.serializer
import org.evoleq.iql.data.iqlSerializers
import org.evoleq.ktorx.client.EmptyParams
import org.evoleq.ktorx.client.Parameters
import org.evoleq.ktorx.result.Result
import org.evoleq.ktorx.result.ResultSerializer
import org.evoleq.ktorx.result.add
import org.evoleq.ktorx.result.serializers
import org.solyton.solawi.bid.application.data.BuildInfo
import org.solyton.solawi.bid.application.data.ReadBackendBuildInfo
import org.solyton.solawi.bid.module.application.data.*
import org.solyton.solawi.bid.module.authentication.data.api.*
import org.solyton.solawi.bid.module.banking.data.*
import org.solyton.solawi.bid.module.banking.data.api.*
import org.solyton.solawi.bid.module.bid.data.api.*
import org.solyton.solawi.bid.module.bid.data.values.AuctionId
import org.solyton.solawi.bid.module.distribution.data.api.*
import org.solyton.solawi.bid.module.permission.data.*
import org.solyton.solawi.bid.module.permission.data.ContextId
import org.solyton.solawi.bid.module.permission.data.api.*
import org.solyton.solawi.bid.module.shares.data.api.*
import org.solyton.solawi.bid.module.shares.data.values.ShareOfferId
import org.solyton.solawi.bid.module.shares.data.values.ShareSubscriptionId
import org.solyton.solawi.bid.module.shares.data.values.ShareTypeId
import org.solyton.solawi.bid.module.user.data.api.*
import org.solyton.solawi.bid.module.user.data.api.organization.*
import org.solyton.solawi.bid.module.user.data.api.userprofile.*
import org.solyton.solawi.bid.module.values.*


fun installSerializers() { if(serializers.isEmpty()) {

    serializers {
        // Standard
        add<Int>(Int.serializer())
        add<Long>(Long.serializer())
        add<String>(String.serializer())
        add<Boolean>(Boolean.serializer())
        add<Double>(Double.serializer())
        add<Unit>(Unit.serializer())
        add(Nothing::class, Unit.serializer())
        // standard values
        add<Uuid>(Uuid.serializer())
        add<UserId>(UserId.serializer())
        add<ProviderId>(ProviderId.serializer())
        add<AccessorId>(AccessorId.serializer())
        add<LegalEntityId>(LegalEntityId.serializer())
        add<UserProfileId>(UserProfileId.serializer())
        add<ModifierId>(ModifierId.serializer())
        add<CreatorId>(CreatorId.serializer())
        add<Username>(Username.serializer())
        add<Password>(Password.serializer())
        add<Firstname>(Firstname.serializer())
        add<Lastname>(Lastname.serializer())
        add<Title>(Title.serializer())
        add<PhoneNumber>(PhoneNumber.serializer())
        add<Description>(Description.serializer())
        //...
        add<Identifier>(Identifier.serializer())
        // API
        add<Parameters>(Parameters.serializer())
        add<EmptyParams>(EmptyParams.serializer())
        // Result
        add<Result<*>>(ResultSerializer)
        add<Result.Failure>(Result.Failure.serializer())
        add<Result.Failure.Message>(Result.Failure.Message.serializer())

        // Api
        add<BuildInfo>(BuildInfo.serializer())
        add<ReadBackendBuildInfo>(ReadBackendBuildInfo.serializer())

        // Authorization
        add<Login>(Login.serializer())
        add<LoggedIn>(LoggedIn.serializer())
        add<RefreshToken>(RefreshToken.serializer())
        add<AccessToken>(AccessToken.serializer())
        add<Logout>(Logout.serializer())
        add<IsLoggedIn>(IsLoggedIn.serializer())
        add<LoggedInAs>(LoggedInAs.serializer())

        // Auctions
        add<CreateAuction>(CreateAuction.serializer())
        add<Auction>(Auction.serializer())
        add<AuctionDetails>(AuctionDetails.serializer())
        add<AuctionDetails.SolawiTuebingen>(AuctionDetails.SolawiTuebingen.serializer())
        add<GetAuctions>(GetAuctions.serializer())
        add<Auctions>(Auctions.serializer())
        add<DeleteAuctions>(DeleteAuctions.serializer())
        add<UpdateAuctions>(UpdateAuctions.serializer())
        add<ConfigureAuction>(ConfigureAuction.serializer())
        add<AuctionId>(AuctionId.serializer())

        // Bid / Bidder
        add<Bid>(Bid.serializer())
        add<Bidder>(Bidder.serializer())
        add<BidderInfo>(BidderInfo.serializer())
        add<NewBidder>(NewBidder.serializer())
        add<ImportBidders>(ImportBidders.serializer())
        add<ImportBiddersFromOrganization>(ImportBiddersFromOrganization.serializer())
        add<DeleteBidders>(DeleteBidders.serializer())
        add<BidRound>(BidRound.serializer())

        // Round
        add<Round>(Round.serializer())
        add<GetRound>(GetRound.serializer())
        add<CreateRound>(CreateRound.serializer())
        add<ChangeRoundState>(ChangeRoundState.serializer())
        add<BidInfo>(BidInfo.serializer())
        add<ExportBidRound>(ExportBidRound.serializer())
        add<BidRoundResults>(BidRoundResults.serializer())
        add<BidResult>(BidResult.serializer())
        add<EvaluateBidRound>(EvaluateBidRound.serializer())
        add<BidRoundEvaluation>(BidRoundEvaluation.serializer())
        add<PreEvaluateBidRound>(PreEvaluateBidRound.serializer())
        add<BidRoundPreEvaluation>(BidRoundPreEvaluation.serializer())
        add<WeightedBid>(WeightedBid.serializer())
        add<AcceptRound>(AcceptRound.serializer())
        add<AcceptedRound>(AcceptedRound.serializer())
        add<RoundComments>(RoundComments.serializer())
        add<RoundComment>(RoundComment.serializer())
        add<CommentOnRound>(CommentOnRound.serializer())

        // Search Bidders
        add<BidderMails>(BidderMails.serializer())
        add<BidderData>(BidderData.serializer())
        add<SearchBidderData>(SearchBidderData.serializer())
        add<AddBidders>(AddBidders.serializer())

        // Shares
        add<Share>(Share.serializer())
        add<Shares>(Shares.serializer())
        add<ShareType>(ShareType.serializer())
        add<ShareTypes>(ShareTypes.serializer())
        add<CreateShareType>(CreateShareType.serializer())
        add<ReadShareTypes>(ReadShareTypes.serializer())
        add<UpdateShareType>(UpdateShareType.serializer())

        // ShareOffer
        add<ShareOffer>(ShareOffer.serializer())
        add<ShareOffers>(ShareOffers.serializer())
        add<CreateShareOffer>(CreateShareOffer.serializer())
        add<ReadShareOffers>(ReadShareOffers.serializer())
        add<ReadPersonalShareOffers>(ReadPersonalShareOffers.serializer())
        add<UpdateShareOffer>(UpdateShareOffer.serializer())

        // ShareSubscription
        add<ShareSubscription>(ShareSubscription.serializer())
        add<ShareSubscriptions>(ShareSubscriptions.serializer())
        add<CreateShareSubscription>(CreateShareSubscription.serializer())
        add<ReadShareSubscriptions>(ReadShareSubscriptions.serializer())
        add<ReadPersonalShareSubscriptions>(ReadPersonalShareSubscriptions.serializer())
        add<UpdateShareSubscription>(UpdateShareSubscription.serializer())
        add<ImportShareSubscription>(ImportShareSubscription.serializer())
        add<ImportShareSubscriptions>(ImportShareSubscriptions.serializer())
        add<RolloverShareSubscriptions>(RolloverShareSubscriptions.serializer())
        add<TransferOwnership>(TransferOwnership.serializer())

        // History
        add<ShareSubscriptionStatusHistories>(ShareSubscriptionStatusHistories.serializer())
        add<ShareSubscriptionStatusHistory>(ShareSubscriptionStatusHistory.serializer())
        add<ShareSubscriptionStatusHistoryEntry>(ShareSubscriptionStatusHistoryEntry.serializer())
        add<ReadShareSubscriptionStatusHistory>(ReadShareSubscriptionStatusHistory.serializer())

        // ShareStatus
        add<ShareStatus>(ShareStatus.serializer())
        add<UpdateShareStatus>(UpdateShareStatus.serializer())
        add<UpdateShareStatuses>(UpdateShareStatuses.serializer())
        add<ChangedBy>(ChangedBy.serializer())
        add<ChangeReason>(ChangeReason.serializer())

        // Share Management Values
        add<ShareSubscriptionId>(ShareSubscriptionId.serializer())
        add<ShareTypeId>(ShareTypeId.serializer())
        add<ShareOfferId>(ShareOfferId.serializer())

        // PricingType
        add<PricingType>(PricingType.serializer())

        // DistributionPoints
        add<DistributionPoint>(DistributionPoint.serializer())
        add<DistributionPoints>(DistributionPoints.serializer())
        add<CreateDistributionPoint>(CreateDistributionPoint.serializer())
        add<UpdateDistributionPoint>(UpdateDistributionPoint.serializer())
        add<DeleteDistributionPoint>(DeleteDistributionPoint.serializer())
        add<ReadDistributionPoint>(ReadDistributionPoint.serializer())
        add<ReadPersonalDistributionPoints>(ReadPersonalDistributionPoints.serializer())
        add<ReadDistributionPoints>(ReadDistributionPoints.serializer())
        add<CreateOrUseAddress>(CreateOrUseAddress.serializer())
        add<CreateOrUseAddress.Create>(CreateOrUseAddress.Create.serializer())
        add<CreateOrUseAddress.Use>(CreateOrUseAddress.Use.serializer())

        // UserManagement
        add<CreateUser>(CreateUser.serializer())
        add<User>(User.serializer())
        add<UserStatus>(UserStatus.serializer())
        add<Users>(Users.serializer())
        add<GetUsers>(GetUsers.serializer())
        add<UserQuery>(UserQuery.serializer())
        add<ChangePassword>(ChangePassword.serializer())
        add<UpdateUser>(UpdateUser.serializer())
        add<UpdateUsername>(UpdateUsername.serializer())
        add<UserProfile>(UserProfile.serializer())
        add<UserProfiles>(UserProfiles.serializer())
        add<ReadUserProfile>(ReadUserProfile.serializer())
        add<ReadUserProfiles>(ReadUserProfiles.serializer())
        add<UpdateUserProfile>(UpdateUserProfile.serializer())
        add<CreateUserProfile>(CreateUserProfile.serializer())
        add<DeleteUserProfile>(DeleteUserProfile.serializer())
        add<UserProfileToImport>(UserProfileToImport.serializer())
        add<ImportUserProfiles>(ImportUserProfiles.serializer())
        add<Address>(Address.serializer())
        add<CreateAddress>(CreateAddress.serializer())
        add<UpdateAddress>(UpdateAddress.serializer())
        add<DeleteAddress>(DeleteAddress.serializer())
        add<ReadAddress>(ReadAddress.serializer())
        add<ReadAddresses>(ReadAddresses.serializer())

        // Permissions
        add<ReadRightRoleContexts>(ReadRightRoleContexts.serializer())
        add<ReadRightRoleContextsOfUser>(ReadRightRoleContextsOfUser.serializer())
        add<ReadRightRoleContextsOfUsers>(ReadRightRoleContextsOfUsers.serializer())
        add<ReadParentChildRelationsOfContexts>(ReadParentChildRelationsOfContexts.serializer())
        add<PutUserRoleContext>(PutUserRoleContext.serializer())
        add<ParentChildRelationsOfContexts>(ParentChildRelationsOfContexts.serializer())
        add<ParentChildRelationsOfContext>(ParentChildRelationsOfContext.serializer())
        add<Context>(Context.serializer())
        add<Contexts>(Contexts.serializer())
        add<Role>(Role.serializer())
        add<Right>(Right.serializer())
        add<UserContext>(UserContext.serializer())
        add<UserToContextsMap>(UserToContextsMap.serializer())
        add<PutRoleRightContext>(PutRoleRightContext.serializer())
        add<ContextName>(ContextName.serializer())
        add<RoleName>(RoleName.serializer())
        add<RightName>(RightName.serializer())
        add<ContextId>(ContextId.serializer())
        add<RightId>(RightId.serializer())
        add<RoleId>(RoleId.serializer())
        add<CreateRole>(CreateRole.serializer())
        add<CreateRight>(CreateRight.serializer())
        add<UpdateRole>(UpdateRole.serializer())
        add<UpdateRight>(UpdateRight.serializer())
        add<DeleteRole>(DeleteRole.serializer())
        add<DeleteRight>(DeleteRight.serializer())
        add<CreateRights>(CreateRights.serializer())
        add<CreateRoles>(CreateRoles.serializer())

        // Applications and Modules
        add<CreateApplication>(CreateApplication.serializer())
        add<UpdateApplication>(UpdateApplication.serializer())
        add<DeleteApplication>(DeleteApplication.serializer())
        add<AddModulesToApplication>(AddModulesToApplication.serializer())
        add<RemoveModulesFromApplication>(RemoveModulesFromApplication.serializer())
        add<CreateModule>(CreateModule.serializer())
        add<CreateModuleOnTheFly>(CreateModuleOnTheFly.serializer())
        add<UpdateModule>(UpdateModule.serializer())
        add<DeleteModule>(DeleteModule.serializer())

        add<ReadApplications>(ReadApplications.serializer())
        add<ReadUserApplications>(ReadUserApplications.serializer())
        add<ReadPersonalUserApplications>(ReadPersonalUserApplications.serializer())
        add<ReadPersonalApplicationContextRelations>(ReadPersonalApplicationContextRelations.serializer())
        add<ReadPersonalModuleContextRelations>(ReadPersonalModuleContextRelations.serializer())
        add<RegisterForApplications>(RegisterForApplications.serializer())
        add<StartTrialsOfApplications>(StartTrialsOfApplications.serializer())
        add<SubscribeApplications>(SubscribeApplications.serializer())
        add<RegisterForModules>(RegisterForModules.serializer())
        add<StartTrialsOfModules>(StartTrialsOfModules.serializer())
        add<SubscribeModules>(SubscribeModules.serializer())
        add<ConnectApplicationToOrganization>(ConnectApplicationToOrganization.serializer())
        add<UpdateOrganizationModuleRelations>(UpdateOrganizationModuleRelations.serializer())
        add<ApiApplications>(ApiApplications.serializer())
        add<ApiUserApplications>(ApiUserApplications.serializer())
        add<ApiApplication>(ApiApplication.serializer())
        add<ApiModule>(ApiModule.serializer())
        add<LifecycleStage>(LifecycleStage.serializer())
        add<LifecycleStage.Empty>(LifecycleStage.Empty.serializer())
        add<LifecycleStage.Registered>(LifecycleStage.Registered.serializer())
        add<LifecycleStage.Trialing>(LifecycleStage.Trialing.serializer())
        add<LifecycleStage.Active>(LifecycleStage.Active.serializer())
        add<LifecycleStage.Paused>(LifecycleStage.Paused.serializer())
        add<LifecycleStage.PaymentFailedGracePeriod>(LifecycleStage.PaymentFailedGracePeriod.serializer())
        add<LifecycleStage.Cancelled>(LifecycleStage.Cancelled.serializer())
        add<LifecycleStage.Churned>(LifecycleStage.Churned.serializer())
        add<ApplicationContextRelation>(ApplicationContextRelation.serializer())
        add<ApplicationContextRelations>(ApplicationContextRelations.serializer())
        add<ModuleContextRelation>(ModuleContextRelation.serializer())
        add<ModuleContextRelations>(ModuleContextRelations.serializer())
        add<ReadApplicationOrganizationContextRelations>(ReadApplicationOrganizationContextRelations.serializer())
        add<ApplicationOrganizationRelation>(ApplicationOrganizationRelation.serializer())
        add<ApplicationOrganizationRelations>(ApplicationOrganizationRelations.serializer())
        add<ApplicationId>(ApplicationId.serializer())
        add<ModuleId>(ModuleId.serializer())
        add<ApplicationName>(ApplicationName.serializer())
        add<ModuleName>(ModuleName.serializer())

        add<UpdateStandardApplicationContext>(UpdateStandardApplicationContext.serializer())
        add<UpdateStandardModuleContext>(UpdateStandardModuleContext.serializer())

        add<FixApplicationRelatedContexts>(FixApplicationRelatedContexts.serializer())
        add<FixModuleRelatedContexts>(FixModuleRelatedContexts.serializer())

        // Organizations
        add<Organizations>(Organizations.serializer())
        add<Organization>(Organization.serializer())
        add<OrganizationId>(OrganizationId.serializer())
        add<Member>(Member.serializer())

        add<CreateOrganization>(CreateOrganization.serializer())
        add<CreateChildOrganization>(CreateChildOrganization.serializer())
        add<ReadOrganizations>(ReadOrganizations.serializer())
        add<UpdateOrganization>(UpdateOrganization.serializer())
        add<DeleteOrganization>(DeleteOrganization.serializer())
        add<AddMember>(AddMember.serializer())
        add<RemoveMember>(RemoveMember.serializer())
        add<UpdateMember>(UpdateMember.serializer())
        add<ImportMembers>(ImportMembers.serializer())

        // Banking
        add<BankAccount>(BankAccount.serializer())
        add<AccountType>(AccountType.serializer())
        add<BankAccounts>(BankAccounts.serializer())
        add<ReadBankAccounts>(ReadBankAccounts.serializer())
        add<ReadBankAccount>(ReadBankAccount.serializer())
        add<ReadPersonalBankAccounts>(ReadPersonalBankAccounts.serializer())
        add<UpdateBankAccount>(UpdateBankAccount.serializer())
        add<CreateBankAccount>(CreateBankAccount.serializer())
        add<DeleteBankAccount>(DeleteBankAccount.serializer())
        add<ImportBankAccount>(ImportBankAccount.serializer())
        add<ImportBankAccounts>(ImportBankAccounts.serializer())

        // Legal Entities
        add<LegalEntity>(LegalEntity.serializer())
        add<LegalEntityType>(LegalEntityType.serializer())
        add<LegalEntities>(LegalEntities.serializer())
        add<CreateLegalEntity>(CreateLegalEntity.serializer())
        add<ReadLegalEntity>(ReadLegalEntity.serializer())
        add<ReadLegalEntitiesOfProvider>(ReadLegalEntitiesOfProvider.serializer())
        add<UpdateLegalEntity>(UpdateLegalEntity.serializer())
        add<DeleteLegalEntity>(DeleteLegalEntity.serializer())

        // Fiscal years
        add<FiscalYear>(FiscalYear.serializer())
        add<FiscalYears>(FiscalYears.serializer())
        add<CreateFiscalYear>(CreateFiscalYear.serializer())
        add<ReadFiscalYears>(ReadFiscalYears.serializer())
        add<ReadFiscalYear>(ReadFiscalYear.serializer())
        add<UpdateFiscalYear>(UpdateFiscalYear.serializer())
        add<DeleteFiscalYear>(DeleteFiscalYear.serializer())

        // Creditor
        add<CreditorIdentifiers>(CreditorIdentifiers.serializer())
        add<CreditorIdentifier>(CreditorIdentifier.serializer())
        add<ReadCreditorIdentifierByLegalEntity>(ReadCreditorIdentifierByLegalEntity.serializer())
        add<CreateCreditorIdentifier>(CreateCreditorIdentifier.serializer())
        add<UpdateCreditorIdentifier>(UpdateCreditorIdentifier.serializer())
        add<CreditorIdentifierId>(CreditorIdentifierId.serializer())
        add<CreditorId>(CreditorId.serializer())

        // Sepa Stuff
        add<SepaMandateId>(SepaMandateId.serializer())
        add<SepaPaymentId>(SepaPaymentId.serializer())
        add<SepaCollectionId>(SepaCollectionId.serializer())
        add<SepaCollectionReferenceId>(SepaCollectionReferenceId.serializer())
        add<MandateReference>(MandateReference.serializer())
        add<MandateReferencePrefix>(MandateReferencePrefix.serializer())
        add<SepaCollectionKey>(SepaCollectionKey.serializer())
        add<RemittanceInformation>(RemittanceInformation.serializer())
        add<LocalInstrument>(LocalInstrument.serializer())
        add<ChargeBearer>(ChargeBearer.serializer())
        add<PurposeCode>(PurposeCode.serializer())

        // Sepa Collections
        add<SepaCollections>(SepaCollections.serializer())
        add<SepaCollection>(SepaCollection.serializer())
        add<CreateSepaCollection>(CreateSepaCollection.serializer())
        add<ReadSepaCollectionsByLegalEntity>(ReadSepaCollectionsByLegalEntity.serializer())
        add<UpdateSepaCollection>(UpdateSepaCollection.serializer())
        add<SepaSequenceType>(SepaSequenceType.serializer())

        // Sepa Mandates
        add<SepaMandates>(SepaMandates.serializer())
        add<SepaMandate>(SepaMandate.serializer())
        add<CreateSepaMandate>(CreateSepaMandate.serializer())
        add<ReadSepaMandatesByCreditorsLegalEntity>(ReadSepaMandatesByCreditorsLegalEntity.serializer())
        add<UpdateSepaMandate>(UpdateSepaMandate.serializer())
        add<UpdateSepaMandates>(UpdateSepaMandates.serializer())
        add<UpdateSepaMandateInSepaCollection>(UpdateSepaMandateInSepaCollection.serializer())
        add<AddSepaMandateToCollection>(AddSepaMandateToCollection.serializer())
        add<RemoveSepaMandateFromCollection>(RemoveSepaMandateFromCollection.serializer())
        add<MandateStatus>(MandateStatus.serializer())
        add<SepaMandateReferenceData>(SepaMandateReferenceData.serializer())
        add<AttachSepaMandateReferenceData>(AttachSepaMandateReferenceData.serializer())
        add<CreateSepaMandateReferenceData>(CreateSepaMandateReferenceData.serializer())
        add<SepaMandateReferenceId>(SepaMandateReferenceId.serializer())
        add<ReadPersonalSepaMandates>(ReadPersonalSepaMandates.serializer())

        // Sepa Payments
        add<SepaPayment>(SepaPayment.serializer())
        add<SepaPayments>(SepaPayments.serializer())
        add<SepaPaymentIds>(SepaPaymentIds.serializer())
        add<CreateSepaPayment>(CreateSepaPayment.serializer())
        add<CreateAdHocSepaPayment>(CreateAdHocSepaPayment.serializer())
        add<CreateSepaPaymentsForCollection>(CreateSepaPaymentsForCollection.serializer())
        add<CreateSepaPaymentSuccessors>(CreateSepaPaymentSuccessors.serializer())
        add<ReadSepaPaymentsByLegalEntity>(ReadSepaPaymentsByLegalEntity.serializer())
        add<UpdateSepaPayment>(UpdateSepaPayment.serializer())
        add<UpdateSepaPayments>(UpdateSepaPayments.serializer())
        add<UpdateSepaPaymentExecutionStatuses>(UpdateSepaPaymentExecutionStatuses.serializer())
        add<AddSepaPaymentToCollection>(AddSepaPaymentToCollection.serializer())
        add<RemoveSepaPaymentFromCollection>(RemoveSepaPaymentFromCollection.serializer())
        add<PaymentExecutionStatus>(PaymentExecutionStatus.serializer())
        add<DeleteSepaPayment>(DeleteSepaPayment.serializer())
        add<DeleteSepaPayments>(DeleteSepaPayments.serializer())

        // Sepa Payment Links
        add<SepaPaymentLink>(SepaPaymentLink.serializer())
        add<SepaPaymentLinks>(SepaPaymentLinks.serializer())
        add<SuccessorKind>(SuccessorKind.serializer())
        add<ReadSepaPaymentLinksByLegalEntity>(ReadSepaPaymentLinksByLegalEntity.serializer())
        add<ReadPersonalSepaPaymentLinks>(ReadPersonalSepaPaymentLinks.serializer())
        // Sepa Payment History

        // Sepa Messages
        add<GenerateSepaMessageForCollection>(GenerateSepaMessageForCollection.serializer())
        add<SepaMessageString>(SepaMessageString.serializer())
        add<SepaMessageVersion>(SepaMessageVersion.serializer())
        add<SepaMessageVersion.PAIN008>(SepaMessageVersion.PAIN008.serializer())
        add<SepaMessage>(SepaMessage.serializer())
        add<SepaMessages>(SepaMessages.serializer())
        add<ReadSepaMessagesByLegalEntityId>(ReadSepaMessagesByLegalEntityId.serializer())
        add<SepaMessageId>(SepaMessageId.serializer())
        add<SepaMessageIdentifier>(SepaMessageIdentifier.serializer())
        add<SepaMessageStatus>(SepaMessageStatus.serializer())
        add<UpdateSepaMessageStatus>(UpdateSepaMessageStatus.serializer())
        add<MergeSepaMessages>(MergeSepaMessages.serializer())
        add<DownloadSepaMessage>(DownloadSepaMessage.serializer())
        // Sepa response from bank




        putAll(iqlSerializers())
    }
} }
